export default function HandleForm(form) {
  this.SUCCESS_CLASS = 'is-success';
  this.SENDING_CLASS = 'is-sending';

  this.sending = false;

  this.getSending = function () {
    return this.sending;
  };

  this.setSending = function (sending) {
    this.sending = sending;

    if (sending) {
      form.classList.add(this.SENDING_CLASS);
    } else {
      form.classList.remove(this.SENDING_CLASS);
    }
  };

  this.handleSuccess = function () {
    const sendForm = new CustomEvent('form-send', {
      bubbles: true,
    });

    form.dispatchEvent(sendForm);

    if (form.classList.contains(this.SENDING_CLASS)) {
      form.classList.remove(this.SENDING_CLASS);
    }

    // Form block
    const formBlock = form.closest('.js-form-block');
    if (formBlock) {
      formBlock.classList.add(this.SUCCESS_CLASS);
    }

    // Form itself
    form.classList.add(this.SUCCESS_CLASS);

    // Form success
    const messageSuccess = form.querySelector('.js-form-success');

    if (messageSuccess) {
      messageSuccess.removeAttribute('aria-hidden');
    }
  };

  this.handleError = function (error) {
    console.error(error);

    const formElements = Array.from(form.elements);

    for (const formElement of formElements) {
      if (formElement && formElement.type !== 'hidden') {
        formElement.focus();

        return false;
      }
    }
  };

  this.checkValidity = function () {
    const formElements = Array.from(form.elements);

    for (const formElement of formElements) {
      if (formElement && !formElement.validity.valid) {
        formElement.focus();

        return false;
      }
    }

    return true;
  };

  this.disableSubmit = function () {
    const formSubmit = form.querySelector('[type="submit"]');

    if (formSubmit) {
      formSubmit.setAttribute('disabled', 'disabled');
    }
  };

  this.enableSubmit = function () {
    const formSubmit = form.querySelector('[type="submit"]');

    if (formSubmit) {
      formSubmit.removeAttribute('disabled');
    }
  };
}
